import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { Filter } from 'react-feather';
import { Link } from 'react-router-dom';
import { AddUser, Href } from '../../../../utils/Constant';
import { setFilterToggle } from '../../../../ReduxToolkit/Reducers/ProductSlice';

const UserListFilterHeader = ({ user_type_id }: { user_type_id: string }) => {
    const { filterToggle } = useAppSelector((state) => state.product);
    const dispatch = useAppDispatch();

    return (
        <div>
            {/* <div className="light-box" onClick={() => dispatch(setFilterToggle())}>
          <Link to={Href}>
            <Filter className={`filter-icon ${filterToggle ? "hide" : "show"}`} />
            <i className={`icon-close filter-close ${filterToggle ? "show" : "hide"}`} />
          </Link>
        </div> */}
            <Link
                className="btn btn-primary"
                to={`${process.env.PUBLIC_URL}/${
                    user_type_id === '2' ? 'suppliers' : 'customers'
                }/detail`}>
                <i className="fa fa-plus" />
                {user_type_id === '2' ? 'Add Supplier' : 'Add Customer'}
            </Link>
        </div>
    );
};

export default UserListFilterHeader;
